<template lang="pug">
    .error
        .error-box
            .error-box__header
                | {{ $i18n.t('errors.without_active_schools') }}
            .error-box__body
                .error-box__text
                    | {{ $i18n.t('errors.page_no_accessFull') }}
        telegram-login-widget.error-box__button(
            v-if="adminInfo && !adminInfo.telegramVerified"
            bot-username="cs_test4444_bot"
            :verified="adminInfo.telegramVerified"
            @verified="onTelegramVerified"
        )
        max-login-widget.error-box__button(
            v-if="adminInfo && !adminInfo.maxVerified"
            :verified="!!adminInfo.maxVerified"
            :adminId="adminInfo.id"
            :poll-with-admin-info="true"
            @verified="onMaxVerified"
        )
        cs-button.error-box__button(
            v-if="adminInfo && (adminInfo.telegramVerified || adminInfo.maxVerified)"
            color="blue"
            pattern="primary-dark-outline",
            @click="createSchool"
        )
            |   {{ $i18n.t('school.school_create_button') }}
        cs-button.error-box__button(
            pattern="primary-dark-outline",
            @click="exit()"
        )
            |   {{ $i18n.t('common.common_navigation_exit') }}
</template>

<script>
    import UserApi from '@/api/user/user';
    import CsButton from '@/elements/CsButton.vue';
    import TelegramLoginWidget from '@/elements/TelegramLoginWidget.vue';
    import MaxLoginWidget from '@/elements/MaxLoginWidget.vue';

    export default {
        components: { TelegramLoginWidget, MaxLoginWidget, CsButton },
        data() {
            return {
                adminInfo: null,
            };
        },
        created() {
            this.getUserInfo();
        },
        methods: {
            getUserInfo() {
                UserApi.getAdminInfo()
                    .then(data => {
                        this.adminInfo = data.user;
                    })
                    .catch(err => console.error(err));
            },
            exit() {
                this.$store.dispatch('logOut');
                this.$router.push({
                    name: 'dashboard',
                });
            },
            createSchool() {
                this.$router.push({
                    name: 'school:register',
                    params: {
                        adminInfo: this.adminInfo,
                    },
                });
            },
            onTelegramVerified(result) {
                if (result && result.user) {
                    this.$router.push({ name: 'dashboard' });
                }
            },
            onMaxVerified(result) {
                if (result && result.user) {
                    this.$router.push({ name: 'dashboard' });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/errors/errors.scss';
</style>
